export const commissionPartnersEn = {
  //START MICHAEL
  COMMISSION_PARTNERS: 'Commission Partners',
  NAME: 'Name',
  EMAIL: 'Email',
  ORGANIZATION: 'Organization',
  PARTNER_TYPE: 'Partner Type',
  COMMISSIONS: 'Commissions',
  CREATE_COMMISSION_PARTNER: 'Create Commission Partner',
  UPDATE_COMMISSION_PARTNER: 'Update Commission Partner',
  REFERRAL_PARTNER: 'Referral Partner',
  COMMISSION_PARTNER_CREATED_SUCCESSFULLY: 'Commission partner created successfully',
  COMMISSION_PARTNER_UPDATED_SUCCESSFULLY: 'Commission partner updated successfully',
  CONNECT_COMMISSION_PARTNER: 'Connect Commission Partner',
  COMMISSION_PARTNER_ALREADY_CONNECTED: 'Commission partner is already connected',
  COMMISSION_PARTNER_AVAILABLE_CONNECT: 'Commission partner already exists. Do you want to connect?',
  COMMISSION_PARTNER_CONNECTED_SUCCESSFULLY: 'Commission partner connected successfully',
  COMMISSION_PARTNER_AVAILABLE_CONNECT_NO_PERMISSION:
    'Commission partner already exists. You do not have permissions to connect.',
  CHECKING_EMAIL: 'Checking email...',
  //END MICHAEL

  // START PATRICIO
  ASSOCIATION: 'Association',
  REFERRAL_PARTNERS: 'Referral Partners',
  CLIENT_ALREADY_HAS_ASSOCIATIONS: 'This client already has associations.',
  ASSOCIATE: 'Associate',
  EDIT_PARTNERS: 'Edit Partners',
  SELECT_COMMISSION_TEMPLATE: 'Select Commission Template',
  SELECT_REFERRAL_PARTNER: 'Select Referral Partner',
  ADD_NEW_ASSOCIATE_COMMISSION_AND_PARTNER: 'Add New Associate Commission & Partner',
  SUBMIT_ASSOCIATIONS: 'Submit',
  COMMISSION_ASSOCIATIONS_ASSIGNED_SUCCESSFULLY: 'Commission associations assigned successfully',
  COMMISSION_ASSOCIATIONS_UPDATED_SUCCESSFULLY: 'Commission associations updated successfully',
  AT_LEAST_ONE_ASSOCIATION_REQUIRED: 'At least one relation must be defined.',
  COMPLETE_ASSOCIATION_RELATIONS: 'Complete all association relations before submitting.',
  PARTNER_CANNOT_BE_REPEATED: 'Referral partner cannot be repeated.',
  REMOVE_RELATION: 'Remove relation',
  LOADING_TEMPLATE_DETAILS: 'Loading template details...',
  TEMPLATE_DETAILS_UNAVAILABLE: 'Template details are temporarily unavailable.',
  //END PATRICIO
}

export const commissionPartnersEs: typeof commissionPartnersEn = {
  //START MICHAEL
  COMMISSION_PARTNERS: 'Socios de Comisión',
  NAME: 'Nombre',
  EMAIL: 'Correo electrónico',
  ORGANIZATION: 'Organización',
  PARTNER_TYPE: 'Tipo de socio',
  COMMISSIONS: 'Comisiones',
  CREATE_COMMISSION_PARTNER: 'Crear socio de comisión',
  UPDATE_COMMISSION_PARTNER: 'Actualizar socio de comisión',
  REFERRAL_PARTNER: 'Socio de referencia',
  COMMISSION_PARTNER_CREATED_SUCCESSFULLY: 'Socio de comisión creado con éxito',
  COMMISSION_PARTNER_UPDATED_SUCCESSFULLY: 'Socio de comisión actualizado con éxito',
  CONNECT_COMMISSION_PARTNER: 'Conectar socio de comisión',
  COMMISSION_PARTNER_ALREADY_CONNECTED: 'El socio de comisión ya está conectado',
  COMMISSION_PARTNER_AVAILABLE_CONNECT: 'El socio de comisión ya existe. ¿Desea conectarlo?',
  COMMISSION_PARTNER_CONNECTED_SUCCESSFULLY: 'Socio de comisión conectado con éxito',
  COMMISSION_PARTNER_AVAILABLE_CONNECT_NO_PERMISSION:
    'El socio de comisión ya existe. No tienes permisos para conectarlo.',
  CHECKING_EMAIL: 'Verificando correo electrónico...',
  //END MICHAEL

  // START PATRICIO
  ASSOCIATION: 'Asociación',
  REFERRAL_PARTNERS: 'Socios de referencia',
  CLIENT_ALREADY_HAS_ASSOCIATIONS: 'Este cliente ya tiene asociaciones.',
  ASSOCIATE: 'Asociar',
  EDIT_PARTNERS: 'Editar socios',
  SELECT_COMMISSION_TEMPLATE: 'Seleccionar plantilla de comisión',
  SELECT_REFERRAL_PARTNER: 'Seleccionar socio de referencia',
  ADD_NEW_ASSOCIATE_COMMISSION_AND_PARTNER: 'Agregar nueva asociación comisión y socio',
  SUBMIT_ASSOCIATIONS: 'Enviar',
  COMMISSION_ASSOCIATIONS_ASSIGNED_SUCCESSFULLY: 'Asociaciones de comisión asignadas con éxito',
  COMMISSION_ASSOCIATIONS_UPDATED_SUCCESSFULLY: 'Asociaciones de comisión actualizadas con éxito',
  AT_LEAST_ONE_ASSOCIATION_REQUIRED: 'Se debe definir al menos una relación.',
  COMPLETE_ASSOCIATION_RELATIONS: 'Completa todas las relaciones antes de enviar.',
  PARTNER_CANNOT_BE_REPEATED: 'El socio de referencia no puede repetirse.',
  REMOVE_RELATION: 'Eliminar relación',
  LOADING_TEMPLATE_DETAILS: 'Cargando detalles de la plantilla...',
  TEMPLATE_DETAILS_UNAVAILABLE: 'Los detalles de la plantilla no están disponibles temporalmente.',
  //END PATRICIO
}
